export const LogoMark = ({ size = 30 }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" fill="none" aria-hidden="true">
    <rect width="64" height="64" rx="14" fill="#111318" stroke="#2E3545" />
    <path d="M15 41a17 17 0 1 1 34 0" stroke="#FF3815" strokeWidth="5" strokeLinecap="round" fill="none" />
    <line x1="32" y1="41" x2="43" y2="27" stroke="#FFB800" strokeWidth="5" strokeLinecap="round" />
    <circle cx="32" cy="41" r="4.5" fill="#F1F5F9" />
  </svg>
);

export default function Logo({ compact = false }) {
  return (
    <span className="inline-flex items-center gap-2.5 select-none">
      <LogoMark />
      {!compact && (
        <span className="font-display text-xl font-black uppercase tracking-wider text-hi">
          Taxed <span className="text-ember">&amp;</span> Tested
        </span>
      )}
    </span>
  );
}
